import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import { RESULTS_DATA_ATTRIBUTE_IDS } from 'constants/data_attributes/product_database/results'

import { refreshProductVariant } from 'actions/database'

import { productType } from 'types/product'

import {
  LoadingIcon,
  LoadingPlaceholderGradient,
  Tooltip
} from '@junglescout/edna'

import { NakedButton } from 'ui_elements/NakedButton/NakedButton'
import { DefaultAppOnly } from 'src/js/containers/common/DefaultAppOnly/DefaultAppOnly'

import { AddGroupButton } from './AddGroupButton'
import { ProductTitle } from './ProductTitle'

const ActionsWrapper = styled.div`
  display: flex;
  gap: 6px;
  position: relative;
  right: 10px;
`
const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  flex-grow: 1;
  margin: auto 10px;
`
const ProductWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-left: ${props => (props.isVariant ? '55px' : '0px')};
`
const ImageLoadingPlaceholder = styled(LoadingPlaceholderGradient)`
  margin-top: 0 !important;
`
const StyledNakedButton = styled(NakedButton)`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;

  &:hover {
    background-color: ${props => props.theme.colors.coolGrey200};
  }
`

export const ProductTitleCell = ({ isVariant, product }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['product_database'])
  const { isLoading, asin, country } = product

  const { database, globalData } = useSelector(store => store)

  const { appType } = globalData
  const {
    data: { selectedCountry }
  } = database

  if (isLoading) {
    return (
      <ProductWrapper isVariant={isVariant}>
        <ImageLoadingPlaceholder width="58px" height="58px" />
        <LoadingWrapper>
          <LoadingPlaceholderGradient width="80%" height="5px" />
        </LoadingWrapper>
      </ProductWrapper>
    )
  }

  return (
    <>
      {isVariant && (
        <ActionsWrapper>
          <DefaultAppOnly>
            <AddGroupButton product={product} />
          </DefaultAppOnly>
          <Tooltip
            content={t(
              'common:RefreshProductButton.refreshProductTooltip',
              'Refresh Product Data'
            )}
            side="top">
            <span>
              <StyledNakedButton
                data-id={RESULTS_DATA_ATTRIBUTE_IDS.Buttons.RefreshProduct}
                onClick={() => {
                  dispatch(
                    refreshProductVariant({
                      asin,
                      country,
                      parentAsin: product.scrapedParentAsin
                    })
                  )
                }}>
                <LoadingIcon size="15px" color="grey900" disableAnimation />
              </StyledNakedButton>
            </span>
          </Tooltip>
        </ActionsWrapper>
      )}
      <ProductTitle
        selectedCountry={selectedCountry}
        appType={appType}
        product={product}
        isProductVariant={isVariant}
      />
    </>
  )
}

ProductTitleCell.defaultProps = {
  isVariant: false
}

ProductTitleCell.propTypes = {
  isVariant: PropTypes.bool,
  product: productType.isRequired
}
